import React, {useState} from "react";

import { Authenticator, withAuthenticator, signOut } from '@aws-amplify/ui-react';


const Faq =()=>{

const [openItems, setOpenItems] = useState({
    
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
    7: false,
    8: false,
    9: false,
    10: false,
    11: false,
    12: false,
    13: false,
    14: false,
    15: false,

 
});

const toggleOpen = (index) => {

    setOpenItems((prevState)=>({
        ...prevState, 
        [index]:!prevState[index]
    }))
};

return (
    <div className="faq-class">
        <h1 className="module-title">Frequently Asked Questions</h1>
<ul className="faq-table">
    <li className="faq-li">
        <div className="faq-button" onClick={()=> toggleOpen(1)}
        >
            {openItems[1] ? "- What are safety training games?" : "+ What are safety training games?"}
        </div>

        <div className={`content ${openItems[1] ? "open" : "closed"}`}>
        <p>Safety training games are interactive learning experiences available in both virtual reality and 360 degree PC-based formats. They are designed to educate users on safety protocols, emergency procedures, and hazard identification in various environments. 
            These games provide a fun and engaging way to train employees or individuals on how to prevent accidents and maintain a safe workplace.</p>
        
</div>
</li>
    <li className="faq-li">
        <div className="faq-button" onClick={()=>toggleOpen(2)}
        >
            {openItems[2] ? "- How do VR safety training games work?" : "+ How do VR safety training games work?"}
        </div>

        <div className={`content ${openItems[2] ? "open" : "closed"}`}>
        <p>VR safety training games engage users through interactive challenges, simulations, and scenarios that mimic real-life situations. 
            These games provide a hands-on approach to learning safety measures, allowing players to make decisions and take actions in a controlled, risk-free environment, reinforcing safety concepts in a memorable way.</p>
</div>
</li>

    <li className="faq-li">
        <div className="faq-button" onClick={()=>toggleOpen(8)}
        >
            {openItems[8] ? "- How do PC-based safety training games work?" : "+ How do PC-based safety training games work?"}
        </div>

        <div className={`content ${openItems[8] ? "open" : "closed"}`}>
        <p>VPC-based 360-degrees interactive safety training games engage users through realistic scenarios, simulations, and challenges that mirror real-life situations. 
            These immersive experiences allow users to explore environments, make decisions, and take actions in a controlled, risk-free setting. This hands-on approach helps reinforce safety concepts effectively, making the learning process both memorable and practical.</p>
</div>
</li>


    <li className="faq-li">
        <div className="faq-button" onClick={()=>toggleOpen(3)}
        >
            {openItems[3] ? "- Are VR safety training games effective?" : "+ Are VR safety training games effective?"}
        </div>

        <div className={`content ${openItems[3] ? "open" : "closed"}`}>
        <p>Yes, VR safety training games are proven to be effective. They offer an interactive and engaging learning experience that helps improve retention of safety knowledge. 
            By simulating real-world situations, they help users develop practical skills to respond to hazards and emergencies, making the learning process both enjoyable and impactful.</p>
        
</div>

</li>


 <li className="faq-li">
        <div className="faq-button" onClick={()=>toggleOpen(9)}
        >
            {openItems[9] ? "- Are PC-based safety training games effective" : "+ Are PC-based safety training games effective"}
        </div>

        <div className={`content ${openItems[9] ? "open" : "closed"}`}>
        <p>Yes, PC-based 360-degrees safety training games are an effective way to learn. They offer an interactive and engaging experience that improves retention of safety knowledge. 
            By simulating real world scenarios, these games help users build practical skills to recognize hazards and respond to emergencies all in a safe, controlled environment. This makes the training both impactful and enjoyable.</p>
        
</div>

</li>


 <li className="faq-li">
        <div className="faq-button" onClick={()=>toggleOpen(10)}
        >
            {openItems[10] ? "- What devices are required to play the safety training games?" : "+ What devices are required to play the safety training games?"}
        </div>

        <div className={`content ${openItems[10] ? "open" : "closed"}`}>
        <p>For the VR games, you would need a PICO 4 VR device. However, PC-based safety training games can be played on standard desktop or laptop computers. 
            They typically require a modern web browser a mouse and keyboard for full interactivity.</p>
        
</div>

</li>


 <li className="faq-li">
        <div className="faq-button" onClick={()=>toggleOpen(11)}
        >
            {openItems[11] ? "- How long does it take to complete a safety training game?" : "+ How long does it take to complete a typical safety training game?"}
        </div>

        <div className={`content ${openItems[11] ? "open" : "closed"}`}>
        <p>The duration varies depending on the complexity of the scenario, but most safety training games take between 15 to 30 minutes to complete.</p>
        
</div>

</li>

 <li className="faq-li">
        <div className="faq-button" onClick={()=>toggleOpen(12)}
        >
            {openItems[12] ? "- Do safety training games require an internet connection?" : "+ Do safety training games require an internet connection?"}
        </div>

        <div className={`content ${openItems[12] ? "open" : "closed"}`}>
        Yes, both VR and PC-based safety training games require an internet connection. However, offline versions are available for VR. 
        If you are interested in accessing the games offline, please contact us on info@VirsatAcademy.com.        
</div>

</li>



    <li className="faq-li">
        <div className="faq-button" onClick={()=>toggleOpen(4)}
        >
            {openItems[4] ? "- Who can benefit from online safety training games?" : "+ Who can benefit from online safety training games?"}
        </div>

        <div className={`content ${openItems[4] ? "open" : "closed"}`}>
        <p>Anyone looking to enhance their knowledge of safety protocols can benefit from online safety training games. 
        These games are especially useful for employees, safety officers, and individuals working in environments where safety risks are present. They are also ideal for organizations looking to train large teams on workplace safety in an engaging and efficient manner.</p>
        
</div>
</li>

    <li className="faq-li">
        <div className="faq-button" onClick={()=>toggleOpen(5)}
        >
            {openItems[5] ? "- Can these safety training games replace traditional training methods?" : "+ Can these safety training games replace traditional training methods?"}
        </div>

        <div className={`content ${openItems[5] ? "open" : "closed"}`}>
        <p>While safety training games are highly effective and engaging, they can complement rather than fully replace traditional training methods. 
            Combining both approaches hands-on practice and interactive gaming can offer a more comprehensive safety education experience, ensuring that users are well-prepared for real life situations.</p>
        
</div>
</li>

    <li className="faq-li">
        <div className="faq-button" onClick={()=>toggleOpen(6)}
        >
            {openItems[6] ? "- What safety topics does VIRSAT safety games cover?" : "+     What safety topics does VIRSAT safety games cover?"}
        </div>

        <div className={`content ${openItems[6] ? "open" : "closed"}`}>
        <p>Virsat safety training games cover a wide range of topics, including workplace safety, fire safety, emergency response procedures, hazard identification, first aid, personal protective equipment (PPE), and specific industry-related risks. 
            These games are tailored to various safety needs, ensuring users are trained on the most relevant topics for their environment.</p>
        
</div>
</li>

    <li className="faq-li">
        <div className="faq-button" onClick={()=>toggleOpen(7)}
        >
            {openItems[7] ? "- Are these games suitable for all ages?" : "+ Are these games suitable for all ages?"}
        </div>

        <div className={`content ${openItems[7] ? "open" : "closed"}`}>
        <p>Safety training games are primarily designed for business use, catering to adults in the workplace. 
            While they are engaging and accessible, the content and complexity are tailored to meet the needs of a professional audience. </p>
</div>
</li>
  </ul>
    </div>
)
}

export default  Faq;